import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

const parseIdArray = (value) => {
    if (!value) return undefined;
    let arr;
    if (Array.isArray(value)) {
        arr = value.map(Number).filter(n => !isNaN(n));
    } else if (typeof value === 'string') {
        arr = value.split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n));
    } else if (typeof value === 'number') {
        arr = [value];
    }
    return arr && arr.length > 0 ? arr : undefined;
};

export const getRetreatListings = async (page = 1, limit = 10, search = '', status = '', location = '', centerId = '', categoryId = '', subCategoryId = '') => {
    try {
        const body = { page };
        if (limit !== undefined && limit !== 10) {
            body.limit = limit;
        }
        if (search) body.search = search;
        if (status) body.status = status;
        if (location) body.location = location;
        if (centerId) body.centerId = centerId;
        if (categoryId) body.categoryId = categoryId;

        // const parsedCategoryId = parseIdArray(categoryId);
        // if (parsedCategoryId) body.categoryId = parsedCategoryId;

        const parsedSubCategoryId = parseIdArray(subCategoryId);
        if (parsedSubCategoryId) body.subCategoryId = parsedSubCategoryId;

        const response = await axios.post(`${apiUrlOne}/retreat-listings/list`, body, {
            headers: {
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat listings:", error);
        throw error;
    }
};

/* Fetch a single retreat by ID (includes category / subcategory associations) */
export const getRetreatById = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-details/retreat/${retreatId}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat by ID:", error);
        throw error;
    }
};

/* Fetch a single retreat for editing (includes categoryId, subCategoryId) */
export const getRetreatListing = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-listings/get-retreat`, {
            params: { retreatId },
            headers: { 'accept': '*/*' }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat listing:", error);
        throw error;
    }
};


/* Fetch active centers for search suggestions */
export const getActiveCenters = async (page = 1, limit = 10, search = '') => {
    try {
        const response = await axios.get(`${apiUrlOne}/centers/active/all?page=${page}&limit=${limit}&search=${search}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching active centers:", error);
        throw error;
    }
};


/* Fetch retreat locations by retreat ID */
export const getRetreatLocations = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-locations/retreat/${retreatId}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat locations:", error);
        throw error;
    }
};

/* Fetch retreat media by retreat ID */
export const getRetreatMedia = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-media/${retreatId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat media:", error);
        throw error;
    }
};

/* Fetch retreat media gallery by retreat ID */
export const getRetreatMediaGallery = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-media/gallery/${retreatId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat media gallery:", error);
        throw error;
    }
};

/* Fetch retreat members by retreat ID */
export const getRetreatMembers = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-members/${retreatId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat members:", error);
        throw error;
    }
};

/* Fetch retreat program by retreat ID */
export const getRetreatProgram = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-program/${retreatId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat program:", error);
        throw error;
    }
};

/* Fetch retreat additional info by retreat ID */
export const getRetreatAdditionalInfo = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-additional-info/${retreatId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat additional info:", error);
        throw error;
    }
};

/* Fetch retreat travel help by retreat ID */
export const getRetreatTravelHelp = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-travel-help/${retreatId}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat travel help:", error);
        throw error;
    }
};

/* Fetch retreat schedule by schedule ID */
export const getRetreatSchedule = async (scheduleId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-schedules/admin/${scheduleId}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat schedule:", error);
        throw error;
    }
};

/* Fetch retreat accommodations by retreat ID */
export const getRetreatAccommodations = async (retreatId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/accommodation-info/admin/${retreatId}`, {
            headers: {
                'accept': '*/*'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching retreat accommodations:", error);
        throw error;
    }
};

/* Update retreat status by retreat ID */
export const updateRetreatStatus = async (retreatId, status, categoryId, subCategoryId, isFeatured, isFeaturedHome, retreatInvoiceType, coordinationCharges, slug, metaTitle, metaDescription, heading, metaOutlet, canonicalUrl, isIndex, imageAltText, ogImage) => {
    try {
        let dataToSend;
        let headers = {};

        if (ogImage instanceof File) {
            const formData = new FormData();
            formData.append('id', retreatId);
            formData.append('status', status || '');
            if (Array.isArray(categoryId)) {
                formData.append('categoryId', JSON.stringify(categoryId));
            } else if (categoryId) {
                formData.append('categoryId', categoryId);
            }
            if (Array.isArray(subCategoryId)) {
                formData.append('subCategoryId', JSON.stringify(subCategoryId));
            } else if (subCategoryId) {
                formData.append('subCategoryId', subCategoryId);
            }
            formData.append('isFeatured', isFeatured);
            formData.append('isFeaturedHome', isFeaturedHome);
            formData.append('retreatInvoiceType', retreatInvoiceType || 'regular');
            if (coordinationCharges !== '' && coordinationCharges !== null && coordinationCharges !== undefined) {
                formData.append('coordinationCharges', Number(coordinationCharges));
            }
            if (slug !== undefined) {
                formData.append('slug', slug);
            }
            formData.append('metaTitle', metaTitle || '');
            formData.append('metaDescription', metaDescription || '');
            formData.append('heading', heading || '');
            formData.append('metaOutlet', JSON.stringify(Array.isArray(metaOutlet) ? metaOutlet : []));
            formData.append('canonicalUrl', canonicalUrl || '');
            formData.append('isIndex', isIndex !== undefined ? (isIndex ? "true" : "false") : "true");
            formData.append('imageAltText', imageAltText || '');
            if (ogImage) {
                formData.append('ogImage', ogImage);
            }

            dataToSend = formData;
            headers = {
                'Content-Type': 'multipart/form-data'
            };
        } else {
            const payload = {
                id: retreatId,
                status: status,
                categoryId: categoryId,
                subCategoryId: subCategoryId,
                isFeatured: isFeatured,
                isFeaturedHome: isFeaturedHome,
                retreatInvoiceType: retreatInvoiceType || 'regular',
                coordinationCharges: coordinationCharges !== '' && coordinationCharges !== null && coordinationCharges !== undefined
                    ? Number(coordinationCharges)
                    : null,
                metaTitle: metaTitle || '',
                metaDescription: metaDescription || '',
                heading: heading || '',
                metaOutlet: Array.isArray(metaOutlet) ? metaOutlet : [],
                canonicalUrl: canonicalUrl || '',
                isIndex: isIndex !== undefined ? (isIndex ? "true" : "false") : "true",
                imageAltText: imageAltText || ''
            };
            if (slug !== undefined) {
                payload.slug = slug;
            }
            if (ogImage !== undefined) {
                payload.ogImage = ogImage;
            }
            dataToSend = payload;
            headers = {
                'Content-Type': 'application/json'
            };
        }

        const response = await axios.put(`${apiUrlOne}/retreat-listings/${retreatId}`, dataToSend, {
            headers
        });
        return response.data;
    } catch (error) {
        console.error("Error updating retreat status:", error);
        throw error;
    }
};